<main class="main-wrap mobile-col-c">
  <div class="left-sidebar-wrapper" *ngIf="this.deviceType !== 'mobile'">
    <app-cart-left-side-bar-page></app-cart-left-side-bar-page>
  </div>
  <div class="middle-wrapper">
    <app-cart-component [cart]="cart" (reloadCart)="reloadCart()"></app-cart-component>
  </div>
  <div class="right-sidebar-wrapper">
    <app-cart-right-side-bar-page [cart]="cart" (reloadCart)="reloadCart()"></app-cart-right-side-bar-page>
  </div>
</main>
